import { render, staticRenderFns } from "./ManageBankAccount.vue?vue&type=template&id=3f6facd1"
import script from "./ManageBankAccount.vue?vue&type=script&lang=js"
export * from "./ManageBankAccount.vue?vue&type=script&lang=js"
import style0 from "./ManageBankAccount.vue?vue&type=style&index=0&id=3f6facd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports